import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Card, CardBody, CardHeader, Colors, ContactCard, Icon as UnstyledIcon,
  Modal, ModalRemove, ModalRestore, ModalSave, Tabs, TextIcon, Title3 } from 'advenio-components'

import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import CompanyAccount from '../CompanyAccount/CompanyAccount'
import CompanyAdicionalParamters from '../CompanyAdicionalParamters'
import CompanyProfileForm from '../CompanyProfileForm/CompanyProfileForm'
import CompanyInvoiceInfoForm from '../CompanyInvoiceInfoForm/CompanyInvoiceInfoForm'
import CompanyContractsForm from '../CompanyContractsForm/CompanyContractsForm'
import { userHasRole } from 'utils/Utils'
import UsoCFDIActions from '../../Data/Redux/UsoCFDIRedux'

const MutedTitle = styled.div`
  margin-bottom: 14px;
  color: ${Colors.gray400};
  font-weight: 700;
  text-transform: uppercase;
`
const DeletedBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  color: ${Colors.white300};
  background-color: ${Colors.blue500};
  font-weight: bold;
  text-align: center;
`
const Icon = styled(UnstyledIcon)`
  margin-right: 8px;
`
const Link = styled.a`
  margin-left: 4px;
  color: ${Colors.white300};
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`

const Views = (user, state, company) => {
  const company_id = String(company.id)
  const views = {
    'Vista General': {
      tabs: [],
      views: [],
    },
    'Vista Basica': {
      tabs: [],
      views: [],
    },
  }
  if (!userHasRole(user, ['Receptionist', 'Director', 'Coordinator'])) {
    views['Vista General'].tabs = [
      { title: 'Perfil' },
      { title: 'Facturación' },
      { title: 'Estado de Cuenta' },
      {
        title: 'Contratos',
        number: state.activeContracts ? state.activeContracts.length : 0,
      },
      {
        title: 'Contratos No Activos',
        number: state.noActvieContracts ? state.noActvieContracts.length : 0,
      },
      // { title: 'Config. Adicionales' },
    ]
    views['Vista General'].views = [
      <CardBody withBorder><CompanyProfileForm company_id={company_id} /></CardBody>,
      <CardBody withBorder><CompanyInvoiceInfoForm company_id={company_id} /></CardBody>,
      <CardBody withBorder><CompanyAccount company={company} /></CardBody>,
      <CardBody withBorder><CompanyContractsForm company_id={company_id} contracts={state.activeContracts} /></CardBody>,
      <CardBody withBorder><CompanyContractsForm company_id={company_id} contracts={state.noActvieContracts} noActvieContracts={state.noActvieContracts.length} /></CardBody>,
      // <CardBody withBorder><CompanyAdicionalParamters company={company} company_id={company.id} /></CardBody>,
    ]
  } else {
    views['Vista Basica'].tabs = [
      {
        title: 'Contratos',
        number: state.activeContracts ? state.activeContracts.length : 0,
      },
    ]
    views['Vista Basica'].views = [
      <CardBody withBorder><CompanyContractsForm company_id={company_id} contracts={state.activeContracts} /></CardBody>,
    ]
  }
  return views
}
class CompanyProfileContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalActivateOpened: false,
      modalSaveOpened: false,
      showLoading: !props.company.name,
      modalRemoveOpened: false,
      toRemoveData: {},
      activeContracts: [],
      noActvieContracts: [],
    }
  }

  componentWillMount() {
    const { company: { contracts }, getUsoCFDI } = this.props
    const activeContracts = []
    const noActvieContracts = []
    getUsoCFDI()
    if (contracts !== undefined) {
      contracts.map((contract) => {
        if (!contract.deleted_at) {
          activeContracts.push(contract)
        } else {
          noActvieContracts.push(contract)
        }
      })
      this.setState({ activeContracts, noActvieContracts })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      this.setState({ showLoading: false })
    }

    if (nextProps.restoreSuccessful && !this.props.restoreSuccessful) {
      this.closeModalActivate()
    }

    if (nextProps.company) {
      const { contracts } = nextProps.company
      const activeContracts = []
      const noActvieContracts = []
      contracts.map((contract) => {
        if (!contract.deleted_at) {
          activeContracts.push(contract)
        } else {
          noActvieContracts.push(contract)
        }
      })
      this.setState({ activeContracts, noActvieContracts })
    }
  }

  addContact = () => this.setState({ modalSaveOpened: true })

  closeModalSave = () => this.setState({ modalSaveOpened: false })

  removeContact = data => () => this.setState({
    toRemoveData: data,
    modalRemoveOpened: true,
  })

  closeModalRemove = () => this.setState({ modalRemoveOpened: false })

  confirmActivateCompany = () => this.setState({ modalActivateOpened: true })

  activateCompany = () => this.props.activateCompany()

  closeModalActivate = () => this.setState({ modalActivateOpened: false })

  editContact = id => () => console.log('Editing:', id)

  render() {
    const {
      company: { name, contacts, contracts, deleted_at },
      company,
      match: { params: { id } }, user,
    } = this.props
    const { modalActivateOpened, modalSaveOpened, showLoading,
      modalRemoveOpened, toRemoveData, noActvieContracts, activeContracts } = this.state
    const isDeleted = !!deleted_at

    if (company.name === undefined) {
      return <Modal isOpened loading />
    }
    return (
      <div>
        {isDeleted && (
          <DeletedBanner>
            <Icon type="warning" width="20" height="20" viewBox="0 0 20 20" /> Esta empresa está dado de baja.
            <Link onClick={this.confirmActivateCompany}>Dar de alta</Link>
          </DeletedBanner>
        )}
        {showLoading && company.name === undefined && <Modal isOpened loading />}
        <Grid fluid>
          <Row>
            <Col md={3}>
              <Card>
                <CardHeader>
                  <Title3 align="center">{name}</Title3>
                </CardHeader>
                <CardBody withBorder>
                  <MutedTitle>Contactos</MutedTitle>
                  {contacts && !showLoading && (
                    <div>
                      {contacts.map((contact) => {
                        const { id: contactId, name: contactName } = contact

                        return (
                          <ContactCard
                            key={contactId}
                            name={contactName}
                            userId={contactId}
                            role={contact.job_title}
                            email={contact.email}
                            phone={contact.contact_numbers}
                            onEdit={!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? this.editContact(contactId) : null}
                            onDelete={!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? this.removeContact({ id: contactId, name: contactName }) : null}
                          />
                        )
                      })}
                      {!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) && (
                        <Button marginLeft="0" marginRight="0" fullWidth onClick={this.addContact}>
                          <TextIcon
                            grayIcon
                            label="Contacto"
                            iconType="plus"
                            iconViewBox="-2 -2 24 24"
                            color="rgba(30,30,30, .3)"
                          />
                        </Button>)
                      }
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col md={9}>
              <Card>
                <Tabs
                  tabs={Views(this.props.user, this.state, company)[!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? 'Vista General' : 'Vista Basica'].tabs}
                  content={Views(this.props.user, this.state, company)[!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? 'Vista General' : 'Vista Basica'].views}
                />
              </Card>
            </Col>
          </Row>
        </Grid>{
        // TODO: Add which centers they have access to
        }<ModalSave
          isOpened={modalSaveOpened}
          titleItem="contacto"
          statePath="contacts"
          typePrefix="COMPANIES_CONTACTS"
          type="create"
          onClose={this.closeModalSave}
          extraParams={{ company_id: id }}
          fields={[
            {
              name: 'name',
              label: 'Nombre',
              path: 'name',
              type: 'input',
              required: true,
              validations: 'maxLength:255',
            },
            {
              name: 'job_title',
              label: 'Puesto',
              path: 'job_title',
              type: 'input',
              required: true,
              validations: 'maxLength:255',
            },
            {
              name: 'email',
              label: 'Correo electrónico',
              path: 'email',
              type: 'input',
              required: true,
              inputType: 'email',
              validations: 'maxLength:255,isEmail',
              validationErrors: {
                isEmail: 'El email debe ser válido',
              },
            },
            {
              name: 'contact_numbers',
              label: 'Telefono',
              path: 'contact_numbers',
              type: 'input',
              required: false,
              validations: 'maxLength:255',
            },
            {
              name: 'comments',
              label: 'Comentarios',
              path: 'comments',
              type: 'input',
              textarea: true,
              colMd: 8,
            },
          ]}
        />
        <ModalRemove
          isOpened={modalRemoveOpened}
          onClose={this.closeModalRemove}
          titleItem="contacto"
          statePath="contacts"
          typePrefix="CONTACTS"
          toRemoveData={toRemoveData}
        />
        <ModalRestore
          isOpen={modalActivateOpened}
          onClose={this.closeModalActivate}
          titleItem="empresa"
          statePath="companies"
          typePrefix="COMPANIES"
          toRestoreData={{ id, name }}
        />
      </div>
    )
  }
}

CompanyProfileContainer.propTypes = {
  /** Data attributes from the current URI */
  match: PropTypes.object.isRequired,
  /** Flag indicating that the Company data is loading */
  loading: PropTypes.bool.isRequired,
  /** The Company's profile data */
  company: PropTypes.object.isRequired,
  /** Reactivate the current company */
  activateCompany: PropTypes.func.isRequired,
  /** Flag indicating that the Company was successfully restored */
  restoreSuccessful: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ companies, ...state }) => ({
  loading: companies.getOne.fetching,
  company: companies.getOne.result,
  restoreSuccessful: companies.restore.success,
  user: state.auth.user,
})

const mapDispatchToProps = (dispatch, { match }) => ({
  activateCompany: () => dispatch(CompaniesActions.restoreRequest(match.params.id)),
  getUsoCFDI: () => dispatch(UsoCFDIActions.getRequest()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyProfileContainer))



// WEBPACK FOOTER //
// ./src/Containers/CompanyProfileContainer/CompanyProfileContainer.jsx